__turbopack_context__.v({
  "className": "avertaregularlight_9faa0ec7-module__GkX0Ia__className",
  "variable": "avertaregularlight_9faa0ec7-module__GkX0Ia__variable",
});
